var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 4.50001V11.7C16.2 12.6941 15.3942 13.5 14.4 13.5H9.90005L5.40005 17.1V13.5H3.60005C2.60594 13.5 1.80005 12.6941 1.80005 11.7V4.50001C1.80005 3.5059 2.60594 2.70001 3.60005 2.70001H14.4C15.3942 2.70001 16.2 3.5059 16.2 4.50001ZM6.30005 7.20001H4.50005V9.00001H6.30005V7.20001ZM8.10005 7.20001H9.90005V9.00001H8.10005V7.20001ZM13.5 7.20001H11.7V9.00001H13.5V7.20001Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.3ece1c913b11b2a1e3c50c4b9ab3afbb.svg";
export { ForwardRef as ReactComponent };